<template>
  <v-app :class="mersBranded ? 'mers' : 'alerus'" :style="siteStyles">
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card class="activity-dialog">
        <v-card-title class="headline">Would you like to continue your session?</v-card-title>
        <v-card-text class="pt-0">You will be logged out after 60 seconds of inactivity.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="appButtonColor" @click="continueSession">Stay Logged In</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar app :color="appHeaderColor">
      <v-toolbar-title v-if="retirementBranded">
        <v-btn
          to="/"
          active-class="retirement-active"
          large
          flat
          depressed
          @click.native.prevent.capture="pushSso"
        >{{ retirementBrandedTitle }}</v-btn>
      </v-toolbar-title>
      <v-toolbar-title v-else-if="mersBranded">
        <a href="https://www.mersofmich.com/">
          <v-img
            class="hidden-xs-only"
            :src="require('@/assets/imgs/' + mersLogoPath())"
            width="140px"
          />
          <v-img
            class="hidden-sm-and-up"
            :src="require('@/assets/imgs/' + mersLogoPath())"
            width="30px"
            height="26px"
          />
        </a>
      </v-toolbar-title>
      <v-toolbar-title v-else>
        <router-link to="/" disabled aria-label="Home" @click.native.prevent.capture="pushSso">
          <v-img
            class="hidden-xs-only"
            :src="require('@/assets/imgs/alerus-dark.svg')"
            width="150px"
            height="26px"
          />
          <v-img
            class="hidden-sm-and-up"
            :src="require('@/assets/imgs/alerus-mobile.svg')"
            width="30px"
            height="26px"
          />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="!mainLoading">
        <v-toolbar-items v-if="$route.name === 'onlinebanking'"></v-toolbar-items>
        <v-toolbar-items
          v-else-if="user && ($route.name === 'account' || $route.name === 'documents')"
        >
          <v-btn to="/myaccount" flat color="#212529">My Profile</v-btn>
          <v-btn v-if="!lastReview && !bizUserDocuments()" to="/mydocuments" flat color="#212529">My Documents</v-btn>
          <v-btn v-if="!mersBranded && !lastReview" @click="pushSso" flat color="#212529">My Alerus</v-btn>
          <v-btn v-else-if="mersBranded && !lastReview" @click="pushSso" flat color="#212529">Return to Dashboard</v-btn>
          <v-btn @click="logout" flat color="#212529" class="border-btn">Log Out</v-btn>
        </v-toolbar-items>
        <v-toolbar-items v-else-if="user && (links.length || actionButtons.length)">
          <v-btn to="/myaccount" flat color="#212529">My Profile</v-btn>
          <!-- <v-btn v-if="actionButtons.length" to="/mydocuments" flat color="#212529">My Documents</v-btn> -->
          <v-btn flat color="#212529" class="user-dropdown">
            <v-icon color="#6E6E6E">account_circle</v-icon>
            <div class="username">{{ user.attributes.given_name ? user.attributes.given_name : user.username }}</div>
            <v-icon color="#6E6E6E">expand_more</v-icon>
          </v-btn>
          <v-btn @click="logout" flat active-class="active-link" class="border-btn" color="#212529">Log Out</v-btn>
        </v-toolbar-items>
        <!-- <v-toolbar-items v-else-if="user || mfa">
          <v-btn
            to="/"
            @click="logout"
            flat
            active-class="active-link"
            :color="appButtonColor"
            class="border-btn"
          >Log Out</v-btn>
        </v-toolbar-items> -->
        <v-toolbar-items v-else-if="!mfa && !user">
          <v-btn
            to="/"
            @click="setState('signedOut')"
            flat
            :color="appButtonColor"
          >Log In</v-btn>
          <v-btn
            to="/signup"
            @click="setState('signUp')"
            flat
            :color="appButtonColor"
          >{{ mersBranded ? 'Create Account' : 'Sign Up' }}</v-btn>
          <v-btn
            v-if="!mersBranded"
            to="/resetpassword"
            @click="setState('forgotPassword')"
            flat
            :color="appButtonColor"
          >Forgot Password</v-btn>
          <v-btn
            v-else
            href="https://www.mersofmich.com/mers/resources/log-in/log-in-help/"
            target="_blank"
            flat
            :color="appButtonColor"
          >Need Help</v-btn>
        </v-toolbar-items>
      </template>
    </v-toolbar>
    <v-content v-if="$route.name !== 'conditions'">
      <div class="bkg-1">
      </div>
      <div class="bkg-2">
        <v-container fluid class="main-block">
          <hollow-dots-spinner
            v-if="mainLoading"
            :animation-duration="1500"
            :dot-size="20"
            :dots-num="3"
            :color="borderColor"
          />
          <router-view v-else ref="view" />
        </v-container>
      </div>
    </v-content>
    <v-content v-else>
      <v-container fluid>
        <router-view ref="view" />
      </v-container>
    </v-content>
    <v-footer height="auto" :color="backgroundColor">
      <v-container fluid>
        <v-layout row wrap align-center justify-center>
          <v-flex shrink class="footer-logo" v-if="mersBranded">
            <!-- <v-img :src="require('@/assets/imgs/MERS-White.png')" width="150px" /> -->
            <div
              class="text-xs-center text-sm-left"
            >&copy; {{ new Date().getFullYear() }} Municipal Employees' Retirement System</div>
          </v-flex>
          <v-flex shrink class="footer-logo" v-else-if="!retirementBranded && !mersBranded">
            <!-- <v-img :src="require('@/assets/imgs/alerus.svg')" width="150px" height="26px" /> -->
            <div
              class="text-xs-center text-sm-left"
            >&copy; {{ new Date().getFullYear() }} Alerus Financial</div>
          </v-flex>
          <v-flex>
            <v-layout row wrap class="footer-links">
              <v-flex align-center shrink>
                <router-link target="_blank" to="/terms-conditions">Terms of Use</router-link>
              </v-flex>
              <v-flex align-center shrink>
                <a target="_blank" href="https://alerus.com/about/privacy-legal/">Privacy</a>
              </v-flex>
              <v-flex align-center shrink>
                <a target="_blank" href="https://alerus.com/accessibility/">Accessibility</a>
              </v-flex>
              <v-flex align-center shrink>
                <a v-if="mersBranded" class="phone-number" href="tel:800-767-6377">800.767.6377</a>
                <a v-else class="phone-number" href="tel:833-325-3787">833.325.3787</a>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import "@/assets/fonts/fonts.css";
import { HollowDotsSpinner } from 'epic-spinners'
export default {
  name: "App",
  data() {
    return {
      dialog: false,
      csc: {
        reg: "Client Service Center - (833-3ALERUS) - 833-325-3787",
        mobile: `Client Service Center - 833-325-3787`,
      },
      mersCSC: "Service Center: 800-767-6377",
      time: 0,
      logTime: 0,
    };
  },
  timers: {
    activityTime: {
      time: process.env.VUE_APP_ACTIVITY_TIME,
      repeat: true,
      autostart: false,
      callback: function () {
        this.openDialog();
      },
    },
    dialogTime: {
      time: process.env.VUE_APP_DIALOG_TIME,
      repeat: true,
      autostart: false,
      callback: function () {
        this.closeDialog();
      },
    },
  },
  watch: {
    user(val) {
      if (val) {
        this.$timer.start("activityTime");
        this.addListeners();
      }
    },
  },
  async created() {
    this.$root.$on("globalSignOut", async () => {
      await this.logout();
    });
  },
  components: {
    HollowDotsSpinner
  },
  computed: {
    ...mapState("user", [
      "confirmed",
      "user",
      "state",
      "sn",
      "retirementBranded",
      "mersBranded",
      "retirementBrandedTitle",
      "mersBrandedTitle",
      "links",
      "actionButtons",
      "lastReview",
      "systemAdmin",
      "mfa",
      "mainLoading",
      "userDetails"
    ]),
    ...mapState("accounts", ["page"]),
    appHeaderColor() {
      return this.mersBranded ? "#F1F1F1" : "#FFF";
    },
    appFooterColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    dialogButtonColor() {
      return this.mersBranded ? "#33715A" : "#CD493C";
    },
    borderColor() {
      return this.mersBranded ? "#bdce9e" : "#40a8cb";
    },
    backgroundColor() {
      return this.mersBranded ? "#f1f1f1" : "#F4F5F8";
    },
    headerColor() {
      return this.mersBranded ? "#2F6C55" : "#0B2A4A";
    },
    primaryColor() {
      return this.mersBranded ? "#2F6C55" : "#297994"
    },
    siteStyles() {
      return {
        '--app-button-color': this.appButtonColor,
        '--background-color': this.backgroundColor,
        '--border-color': this.borderColor,
        '--header-color': this.headerColor,
        '--primary-color': this.primaryColor,
        '--dialog-button-color': this.dialogButtonColor
      }
    }
  },
  methods: {
    ...mapMutations("user", [
      "emptyUser",
      "unsetConfirmed",
      "setState",
      "setSN",
      "setSNAnswer",
      "setError",
      "setLoading",
      "setAnswer",
      "setPhones",
      "setStraightSso",
      "setLinks",
      "setAWSMfa",
      "setMfa",
      "setHub"
    ]),
    ...mapMutations("accounts", ["setPage"]),
    emptyTime() {
      // console.log("empty time");
      this.$timer.stop("activityTime");
      this.$timer.start("activityTime");
    },
    emptyDialogTime() {
      this.$timer.stop("dialogTime");
      this.$timer.start("dialogTime");
    },
    addListeners() {
      window.addEventListener("click", this.emptyTime);
      window.addEventListener("mouseover", this.emptyTime);
    },
    removeListeners() {
      window.removeEventListener("click", this.emptyTime);
      window.removeEventListener("mouseover", this.emptyTime);
    },
    addDialogListeners() {
      window.addEventListener("click", this.emptyDialogTime);
      window.addEventListener("mouseover", this.emptyDialogTime);
    },
    removeDialogListeners() {
      window.removeEventListener("click", this.emptyDialogTime);
      window.removeEventListener("mouseover", this.emptyDialogTime);
    },
    async wait(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },
    checkLocation() {

    },
    closeDialog() {
      this.$timer.stop("dialogTime");
      this.dialog = false;
      this.removeDialogListeners();
      this.logout();
    },
    openDialog() {
      this.$timer.stop("activityTime");
      this.removeListeners();
      this.addDialogListeners();
      this.dialog = true;
      this.$timer.start("dialogTime");
    },
    continueSession() {
      this.removeDialogListeners();
      this.addListeners();
      this.$timer.stop("dialogTime");
      this.$timer.start("activityTime");
      this.dialog = false;
    },
    setLoginState(state) {
      this.setState(state);
      this.$router.push("/");
    },
    async logout() {
      this.emptyError()
      await this.$Amplify.Auth.signOut();
      this.setState("signedOut");
      this.setSN(false);
      this.setSNAnswer(false);
      this.emptyUser();
      this.unsetConfirmed();
      this.setError(false);
      this.setMfa(false);
      this.setLoading(false);
      this.setAnswer({});
      this.setPhones([]);
      this.setLinks([]);
      this.$root.$emit("removeExtras");
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.setAWSMfa(false);
    },
    emptyError() {
      if (this.$refs.view.$refs.auth) {
        if (this.$refs.view.$refs.auth.$refs.signInComp) {
          this.$refs.view.$refs.auth.$refs.signInComp.mfaError = false
          this.$refs.view.$refs.auth.$refs.signInComp.mfaErrorMessage = ""
          this.$refs.view.$refs.auth.$refs.signInComp.mfaAnswer = ""
        }
      }
    },
    pushSso() {
      if (!this.systemAdmin && !this.lastReview) {
        this.unsetConfirmed();
        this.setStraightSso(true);
      }
      if (this.$route.path !== "/") this.$router.push("/")
    },
    mersLogoPath() {
      if (this.$route.name === 'account' || this.$route.name === 'documents') {
        return 'myMerslogo.png';
      } else {
        return 'MERS-Green-Black.png';
      }
    },
    bizUserDocuments() {
      if (this.userDetails.subUsers !== null) {
        let subUsers = JSON.parse(this.userDetails.subUsers)
        if (subUsers.items.some(x => x.type === 'commercial')) {
          console.log('commercial docs')
          return true
        }
      }
      return false
    }
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}
body {
  //font-family: "Poppins";
  .alerus {
    font-family: 'Source Sans Pro', sans-serif;
  }
  .mers {
    font-family: "Ubuntu";
    .Section__sectionHeader___2djyg, .Input__inputLabel___3VF0S, .Input__inputLabel___nQolz {
      font-weight: initial;
    }
    .v-btn__content {
      font-size: 1.2rem;
    }
    .mers-auth {
      padding-top: 0 !important;
      border-top: none !important;
      .v-btn__content {
        font-size: inherit;
      }
    }
  }
  margin: 0;
  height: 100%;
}
.activity-dialog {
  padding: 1rem;
  .v-btn {
    background-color: var(--dialog-button-color) !important;
  }
}
.hollow-dots-spinner {
  margin: 0 auto;
}
.footer-logo {
  margin-right: .5rem;
  color: var(--header-color);
}
.footer-links {
  a {
    text-decoration: none;
    margin: 0 .5rem;
    font-size: 1rem;
    color: var(--primary-color)
  }
  .phone-number {
    color: #212529;
  }
}
#app {
  //height: 100%;
}
.bkg-1{
  background-color: var(--app-button-color);
  height: 15rem;
}
.bkg-2{
  background-color: var(--background-color);
  height: calc(100% - 15rem);
}
.main-block {
  top: -15rem;
  position: relative;
  padding: 4rem 0 0;
  margin-bottom: -11rem;
}
.active {
  background-color: #d9d7d7;
}
.v-toolbar__items {
  .v-btn__content {
    text-transform: initial;
  }
}
.theme--light.v-footer {
  display: flex;
}
.v-btn__content {
  text-transform: initial;
  font-size: 16px;
  i {
    margin-right: 0.25rem;
  }
}
.border-btn {
  &::before {
    display: none;
  }
  .v-btn__content {
    padding: .5rem 1rem;
    border: 1px solid #ddd;
  }
}
.user-dropdown {
  border-left: 1px solid #ddd;
}
.load-button {
  padding: .75rem 1rem;
  background-color: #cd493c !important;
  min-width: 125px;
  height: auto;
}
.Input__input___3e_bf {
  &:focus-visible {
    outline: none;
    border: 1px solid !important;
    border-color: var(--border-color) !important;
  }
}
.Section__sectionBody___ihqqd{
  margin-bottom: 3rem;
}
.welcome-text {
  font-size: 1.25rem;
  margin-top: 0.5rem;
  font-weight: initial;
  color: #212529;
  a {
    color: var(--primary-color);
    font-weight: 600;
  }
  &.bold-shark {

  }
}
.login-form input {
  border-radius: 0;
}
:-ms-input-placeholder {
  color: #9c9c9c !important;
}
@media (max-width: 1263px) {
  .main-box {
    padding: 1rem 3rem !important;
  }
}
@media (max-width: 959px) {
  .footer-logo {
    .v-image {
      margin: 0 auto;
    }
  }
}
@media (max-width: 768px) {
  .authentication {
    max-width: 90%;  
  }
  .main-box {
    padding: 2rem 1rem !important;
  }
  .main-block {
    padding: 0;
    top: -9rem;
    margin-bottom: -7rem;
  }
  .main-profile {
    width: 90%;
  }
  .bkg-1 {
    height: 11rem;
  }
  .bkg-2 {
    height: calc(100% - 11rem);
  }
}
@media (max-width: 599px) {
  .authentication {
    max-width: 100%;
  }
  .main-profile {
    width: 100%;
    padding: 1rem;
    .grid-list-lg {
      padding-top: 0 !important;
    }
  }
  .profile-header {
    margin-top: 0;
  }
  .main-block {
    top: -11rem;
    margin-bottom: -11rem;
  }
  .mfa-submit {
    .submit-right {
      justify-content: center;
    }
  }
  .v-input--radio-group__input {
    flex-direction: column !important;
  }
  .delivery-pref {
    min-width: initial;
  }
  .group-btn {
    margin-top: 0;
    margin-bottom: 2rem;
  }
  .v-image {
    margin: 0 auto;
  }
  .footer-links {
    justify-content: center;
    span {
      display: none;
    }
  }
  .footer-logo {
    // margin-bottom: 0.5rem;
  }
  .Section__sectionFooterPrimaryContent___2r9ZX{
    margin-bottom: 0;
    display: initial !important;
    text-align: center;
    .lht-blue {
      margin-right: 0 !important;
    }
  }
}
@media (max-width: 375px) {
  .migration .v-btn {
    padding: 0;
    min-width: 70px;
  }
}
</style>